/*
  Avisame cuando vuelva — logica compartida entre la ficha de producto y las
  tarjetas del listado. Usa el Back in Stock nativo de Klaviyo, asi el aviso
  se dispara solo cuando Shopify repone inventario.
*/
(function () {
  'use strict';

  if (window.norteAvisameCargado) return;
  window.norteAvisameCargado = true;

  var CLAVE = window.norteKlaviyoId || 'QRJiKB';
  /* Endpoint documentado vigente. El viejo (/onsite/components/...) sigue
     respondiendo en muchas cuentas pero devuelve otro formato, asi que se
     deja solo como respaldo si el actual falla. */
  var API = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + CLAVE;
  var API_VIEJO = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';

  function valido(correo) {
    return !!correo && correo.indexOf('@') > 0 && correo.indexOf('.') > -1;
  }

  function porRespaldo(correo, varianteId) {
    var d = new URLSearchParams();
    d.append('a', CLAVE);
    d.append('email', correo);
    d.append('variant', varianteId);
    d.append('platform', 'shopify');
    return fetch(API_VIEJO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: d.toString()
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) { return !!(j && j.success); })
      .catch(function () { return false; });
  }

  /* Resuelve true si Klaviyo acepto la suscripcion. Exito = 202 sin cuerpo. */
  function suscribir(correo, varianteId) {
    var cuerpo = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: correo } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + varianteId
            }
          }
        }
      }
    };

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) {
        if (r.status === 202 || r.ok) return true;
        return porRespaldo(correo, varianteId);
      })
      .catch(function () { return porRespaldo(correo, varianteId); });
  }

  window.norteAvisame = { suscribir: suscribir, valido: valido };

  /* ---------- dialogo del listado ---------- */

  var dlg = document.querySelector('[data-avisame-dialogo]');
  if (!dlg) return;

  var form    = dlg.querySelector('[data-dlg-form]');
  var input   = dlg.querySelector('[data-dlg-input]');
  var boton   = dlg.querySelector('[data-dlg-enviar]');
  var estado  = dlg.querySelector('[data-dlg-estado]');
  var titulo  = dlg.querySelector('[data-dlg-titulo]');
  var variante = null;
  var abridor = null;

  function decir(txt, esError) {
    estado.textContent = txt;
    estado.hidden = false;
    estado.classList.toggle('norte-avisame__estado--error', !!esError);
  }

  function abrir(varianteId, nombre, origen) {
    variante = varianteId;
    abridor = origen || null;
    titulo.textContent = nombre ? 'Avísame cuando vuelva ' + nombre : 'Avísame cuando vuelva';
    form.hidden = false;
    estado.hidden = true;
    input.value = '';
    boton.disabled = false;
    boton.textContent = 'Avisarme';
    dlg.hidden = false;
    document.body.classList.add('norte-avisame-abierto');
    setTimeout(function () { input.focus(); }, 40);
  }

  function cerrar() {
    dlg.hidden = true;
    document.body.classList.remove('norte-avisame-abierto');
    if (abridor && abridor.focus) abridor.focus();
    abridor = null;
  }

  /* Delegado en document: las tarjetas se repintan al filtrar por AJAX, asi
     que enlazar cada boton al cargar dejaria muertos los que llegan despues. */
  document.addEventListener('click', function (ev) {
    var disparador = ev.target.closest('[data-avisame-variante]');
    if (disparador) {
      /* La tarjeta entera es un enlace al producto: sin esto, el clic navega. */
      ev.preventDefault();
      ev.stopPropagation();
      abrir(disparador.dataset.avisameVariante, disparador.dataset.avisameTitulo, disparador);
      return;
    }
    if (ev.target.closest('[data-dlg-cerrar]') || ev.target === dlg) cerrar();
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !dlg.hidden) cerrar();
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var correo = (input.value || '').trim();
    if (!valido(correo)) {
      decir('Escribe un correo válido.', true);
      input.focus();
      return;
    }
    boton.disabled = true;
    boton.textContent = 'Enviando…';
    estado.hidden = true;

    suscribir(correo, variante).then(function (ok) {
      if (ok) {
        form.hidden = true;
        decir('Listo. Te avisamos en cuanto vuelva.', false);
      } else {
        decir('No pudimos registrarte. Intenta de nuevo.', true);
        boton.disabled = false;
        boton.textContent = 'Avisarme';
      }
    });
  });
})();
